import { createPrefetchableAsyncPaginatedDataContext, pageDataErrorHandler } from 'src/app/shared/contexts/asyncData';

import { getFirstPageData, getNextPageData } from './api';

export const {
	Context: LocalPagePaginatedTrendingPetitionsDataContext,
	Provider: LocalPagePaginatedTrendingPetitionsDataContextProvider,
	useContext: useLocalPagePaginatedTrendingPetitionsData,
	useAsyncData: useLocalPagePaginatedTrendingPetitionsDataFromApi,
	prefetchAsyncData: prefetchLocalPagePaginatedTrendingPetitionsDataFromApi,
} = createPrefetchableAsyncPaginatedDataContext({
	name: 'LocalPagePaginatedTrendingPetitionsDataContext',
	dataProperty: 'trendingPetitionsPaginatedData',
	getFirstPageData,
	getNextPageData,
	getUniqueId: (slug, { listTagsFilter }) => [slug, listTagsFilter].join('|'),
	hookDeps: (slug, { listTagsFilter }) => [slug, listTagsFilter],
	errorHandler: pageDataErrorHandler(),
});
